import React, {Fragment} from 'react';
import _ from 'lodash';
import {
  SideLabelTextAreaWithRefInput,
  SideLabelPercentWithRefInput,
  SecuritizedInput,
 } from '../../FormSectionComponents';

class PrepaymentTermsSpreadMaintenance extends React.Component {
  renderSecuritizedInput = (formik) => {
    let dateComponents = formik.values.prepaymentTerms.securitizationDate ? formik.values.prepaymentTerms.securitizationDate.split("-") : '';
    if(dateComponents[1] && !formik.values.prepaymentTerms.securitizationMonth){
      formik.setFieldValue("prepaymentTerms.securitizationMonth",(dateComponents[1]-1).toString(),false);
      formik.setFieldValue("prepaymentTerms.securitizationYear",dateComponents[0],false);
    }
    return(
      <SecuritizedInput 
        formk={formik}
        label="Securitization"
        checkboxFieldName="Securitized "
        midLabel="Month: "
        isSecuritized={formik.values.prepaymentTerms.isSecuritized}
        securitizationDate={formik.values.prepaymentTerms.securitizationDate}
        isDisabled = {!this.props.isEditing}
        onChange = {(o) => {
          this.setState(o);
        }}
      />
    )
  }

  render(){
    const {isEditing} = this.props;
    return (
      <Fragment>
         <SideLabelPercentWithRefInput
          label="Exit Fee"
          hasBorder
          placeholder="Exit Fee"
          fieldName="prepaymentTerms.exitFee"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Lockout Period"
          hasBorder
          placeholder="Lockout Period"
          fieldName="prepaymentTerms.lockoutPeriod"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Par Prepayment Period"
          hasBorder
          placeholder="Par Prepayment Period"
          fieldName="prepaymentTerms.parPrepaymentPeriod"
          isDisabled={!isEditing}/>
        <SideLabelTextAreaWithRefInput
          label="Spread Maintenance Period"
          hasBorder
          placeholder="Spread Maintenance Period"
          fieldName="prepaymentTerms.spreadMaintenance"
          isDisabled={!isEditing}/>
          
        <SideLabelTextAreaWithRefInput
          label="Notice Period"
          hasBorder
          placeholder="Notice Period"
          fieldName="prepaymentTerms.noticePeriod"
          isDisabled={!isEditing}/>
        <SideLabelTextAreaWithRefInput
          label="Calculation Methodology"
          hasBorder
          placeholder="Calculation Methodology"
          fieldName="prepaymentTerms.calculationMethodology"
          isDisabled={!isEditing}/>
        {this.renderSecuritizedInput(this.props.formik)}
        <SideLabelTextAreaWithRefInput
          label="Other"
          placeholder="Other"
          fieldName="prepaymentTerms.other"
          isDisabled={!isEditing}/>  
      </Fragment>
  )};
}
export default PrepaymentTermsSpreadMaintenance;